import React from 'react';
import LessonForm from '@components/lessonForm/LessonForm';
import withLesson from '@hoc/withLesson';
import { useGetLessonObjectivesQuery, useGetCurrentUserQuery } from '@teachur/http-client';

interface EditLessonProps {
  lesson: Lesson;
}

const EditLesson: React.FC<EditLessonProps> = ({ lesson }) => {
  const { data: user } = useGetCurrentUserQuery();
  const { data: objectives, isLoading } = useGetLessonObjectivesQuery(lesson.id);

  if (!user || !objectives || isLoading) {
    return null;
  }

  return <LessonForm lesson={lesson} objectives={objectives as any} />;
};

const ConnectedEditLesson = withLesson(EditLesson);

const Page = () => <ConnectedEditLesson />;

export default Page;
